import React from 'react'
import Logo from "../../Logo"
import MenuInicioSuscrito from '../../../pages/inicioSuscrito/MenuInicioSuscrito'
import Redes from '../../Redes'
import Footer from "../../Footer"
import "../../../../styles/registrado/noticias/slideNoticias3.css"

function SlideNoticias3() {
  return (
    <>
      <Logo />
      <MenuInicioSuscrito />
      <Redes />
      <div className='body-slideNoticias3'>
        <section className='section-slideNioticias3'>
          <h3 className='subtittle-slideNoticia3'>
            Este nuevo gravamen se aplicará en solo una fase de la cadena. Los expertos aseguran que se trasladará al usuario en los precios
          </h3>
          <p className='paragraph-slideNoticia3'>
            <strong>Antes de terminar el año 2023 entran en vigor los nuevos impuestos saludables a los alimentos procesados estipulados en la reforma 
            tributaria del año pasado</strong> y que, según los analistas, impactará en el bolsillo de los consumidores de forma escalonada 
            hasta 2025.
          </p>
          <p className='paragraph-slideNoticia3'>
            Este gravamen, según explicó el director de la Dian, Luis Carlos Reyes, <strong>será monofásico, es decir que el 
            impuesto solo se causará una vez.</strong>
          </p>
          <p className='paragraph-slideNoticia3'>
            Iván Felipe Aguirre, abogado tributario, aseguró que este tipo de impuestos, a diferencia de los plurifásicos, 
            “<strong>son aquellos que se causan en una sola fase</strong>”.
          </p>
          <p className='paragraph-slideNoticia3'>
            Según mencionó el Ministerio de Hacienda, <strong>este impuesto tendrá efecto directo en 21 productos de los 443 artículos que 
            componen la canasta básica del IPC</strong> con la cual el Dane mide la inflación.
          </p>
          <p className='paragraph-slideNoticia3'>
            Algunos de estos son <strong>las salchichas, las bebidas gaseosas, las bolsas de papas, galletas de chocolate, confiterías, 
            tortas</strong>, entre otros.
          </p>
          <p className='paragraph-slideNoticia3'>
            Por el contrario, algunos artículos que no se ven afectados son, entre otros, <strong>el pan, el salchichón y la mortadela.</strong>
          </p>
          <p className='paragraph-slideNoticia3'>
            Este incremento, de acuerdo con la ley, se hará de forma escalonada, <strong>con un alza de 10% para lo que resta de 2023, otro que 
            será de 15% en 2024 y de 20% en 2025.</strong>
          </p>
          <p className='paragraph-slideNoticia3'>
            Según los cálculos iniciales, un paquete de salchichas de siete unidades, que actualmente tiene un precio de $10.300, 
            <strong>tendrá un costo de $11.330 al cierre de 2023, que para el próximo año subirá $11.845 y en 2025 será de $12.360.</strong>
          </p>
        </section>

        <section className='section-slideNioticias3'>
          <h3 className='subtittle-slideNoticia3'>¿Cómo se cobrará el impuesto?</h3>
          <p className='paragraph-slideNoticia3'>
            “<strong>Si es un productor de los bienes sujeto al impuesto, este se debe incluir en la factura de venta, si es un importador 
            se causa en el momento de la importación y se traslada al consumidor vía precio</strong>”, mencionó a su vez Jairo Higuita, 
            socio director de Jiménez Higuita Rodríguez.
          </p>
          <p className='paragraph-slideNoticia3'>
            De forma más técnica, Laura Galeano, socia de DLA Piper Martínez Beltrán, precisó que el productor <strong>deberá incluir el 
            valor del impuesto en la factura de venta siendo así el responsable de su recaudo, al tiempo que será el comprador 
            sobre quien recaerá la carga económica del gravamen.</strong>
          </p>
          <p className='paragraph-slideNoticia3'>
            De esta forma, Diego Torres, abogado de Cuatrecasas, mencionó que “<strong>es muy difícil que el consumidor no se vea afectado 
            en la práctica</strong>”.
          </p>
          <p className='paragraph-slideNoticia3'>
            “Si bien en varios casos el consumidor no va a pagar directamente el impuesto, <strong>lo cierto es que los costos de la producción 
            de las bebidas azucaradas y de los alimentos ultraprocesados van a verse distorsionados por estos nuevos impuestos</strong> y, 
            muy probablemente, la carga económica la terminará asumiendo el consumidor, por la vía de un mayor precio de venta”, 
            manifestó Torres.
          </p>
          <p className='paragraph-slideNoticia3'>
            Una precisión que sí hizo el director de la Dian fue que <strong>en el caso de los restaurantes este impuesto no se le cobrará 
            al consumidor.</strong>
          </p>
          <p className='paragraph-slideNoticia3'>
            “<strong>No olvidemos que el objetivo principal de estos impuestos es desestimular el consumo de ciertos productos que tienen efectos 
            adversos para la salud por su contenido de sodio, azúcar o grasas saturadas</strong>, y que la forma evitar que estos productos sean 
            consumidos es haciéndolos más costos vía impuestos”, remarcó Galeano.
          </p>
          <p className='paragraph-slideNoticia3'>
            El Ministerio de Hacienda confirmó que esta medida <strong>sí tendrá un efecto dominó sobre la inflación del país, 
            la cual se mantiene en 10,99%, a corte de septiembre pasado.</strong>
          </p>
          <p className='paragraph-slideNoticia3'>
            Según Ricardo Bonilla, líder de esta cartera, se espera que <strong>el impacto del gravamen sobre la inflación total sea de 0,21 
            puntos porcentuales en 2023, de 0,11 puntos porcentuales en 2024 y de 0,12 puntos porcentuales en 2025.</strong>
          </p>
        </section>
      </div>
      <Footer />
    </>
  )
}

export default SlideNoticias3
